export function getAvatarLetters(username?: string, email?: string): string {
  const source = username?.trim() || email?.trim() || ''
  if (!source) return ''

  // If it's an email, use the part before '@'
  const base = source.includes('@') ? source.split('@')[0] : source

  // Split into words on spaces, dots, underscores, hyphens (covers "john.doe", "john_doe", "John Doe")
  const words = base.split(/[\s._-]+/).filter(Boolean)

  if (words.length >= 2) {
    return (words[0][0] + words[1][0]).toUpperCase()
  }

  return base.slice(0, 2).toUpperCase()
}
